import { render, staticRenderFns } from "./FixAddressesForm.vue?vue&type=template&id=2c028585"
import script from "./FixAddressesForm.vue?vue&type=script&lang=js"
export * from "./FixAddressesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports